var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBugdroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.99121 16H25.9912V18.5C25.9912 21.1522 24.9376 23.6957 23.0623 25.5711C21.1869 27.4464 18.6434 28.5 15.9912 28.5C13.339 28.5 10.7955 27.4464 8.92014 25.5711C7.04478 23.6957 5.99121 21.1522 5.99121 18.5V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9912 18.5C25.9912 21.1522 24.9376 23.6957 23.0623 25.5711C21.1869 27.4464 18.6434 28.5 15.9912 28.5C13.339 28.5 10.7955 27.4464 8.92014 25.5711C7.04478 23.6957 5.99121 21.1522 5.99121 18.5V13.5C5.99121 10.8478 7.04478 8.3043 8.92014 6.42893C10.7955 4.55357 13.339 3.5 15.9912 3.5C18.6434 3.5 21.1869 4.55357 23.0623 6.42893C24.9376 8.3043 25.9912 10.8478 25.9912 13.5V18.5Z",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9912 16H5.99121",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9912 11.5C19.9912 11.7761 19.7674 12 19.4912 12C19.2151 12 18.9912 11.7761 18.9912 11.5C18.9912 11.2239 19.2151 11 19.4912 11C19.7674 11 19.9912 11.2239 19.9912 11.5Z",
    fill: "white",
    stroke: "#FF6636",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9912 11.5C12.9912 11.7761 12.7674 12 12.4912 12C12.2151 12 11.9912 11.7761 11.9912 11.5C11.9912 11.2239 12.2151 11 12.4912 11C12.7674 11 12.9912 11.2239 12.9912 11.5Z",
    fill: "white",
    stroke: "#FF6636",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99121 3.5L9.53049 5.867",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9913 3.5L22.452 5.86708",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugdroid);
export default __webpack_public_path__ + "static/media/bugdroid.7e027d2e6d31a13b87ec8b40246fc35b.svg";
export { ForwardRef as ReactComponent };